module.exports = __webpack_public_path__ + "static/media/sparksLogoSticky.1cfe5d80.png";